import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
} from "@reduxjs/toolkit";

// AWS
import { API, Auth } from "aws-amplify";

const initialOther = async () => {
  try {
    const carGroups = await API.get("MoneyHubAdmin", `/leasing/group`, {
      queryStringParameters: {
        type: "CAR",
        category: "NTF",
      },
    });
    const motobikeGroups = await API.get("MoneyHubAdmin", `/leasing/group`, {
      queryStringParameters: {
        type: "CAR",
        category: "NTF",
      },
    });
    const allTFGroups = await API.get("MoneyHubAdmin", `/leasing/group`, {
      queryStringParameters: {
        type: "ALL",
        category: "TF",
      },
    });
    const interestCar = await API.get("MoneyHubAdmin", `/leasing/interest`, {
      queryStringParameters: {
        name: "INTEREST_CAR",
      },
    });
    const interestMotobike = await API.get(
      "MoneyHubAdmin",
      `/leasing/interest`,
      {
        queryStringParameters: {
          name: "INTEREST_MOTORBIKE",
        },
      }
    );
    const interestNtfPenaltyCar = await API.get(
      "MoneyHubAdmin",
      `/leasing/interest`,
      {
        queryStringParameters: {
          name: "INTEREST_NTF_PENALTY_CAR",
        },
      }
    );
    const interestNtfPenaltyMotobike = await API.get(
      "MoneyHubAdmin",
      `/leasing/interest`,
      {
        queryStringParameters: {
          name: "INTEREST_NTF_PENALTY_MOTORBIKE",
        },
      }
    );
    const interestPenaltyTF = await API.get(
      "MoneyHubAdmin",
      `/leasing/interest`,
      {
        queryStringParameters: {
          name: "INTEREST_PENALTY_TF",
        },
      }
    );
    const interestTF = await API.get(
      "MoneyHubAdmin",
      `/leasing/interestSetting`,
      {
        queryStringParameters: {
          setting: "INTEREST_TF",
        },
      }
    );
    const switchVal = await API.get(
      "MoneyHubAdmin",
      `/leasing/interestSetting`,
      {
        queryStringParameters: {
          setting: "SWITCH_VAL",
        },
      }
    );

    const feeTransfer = await API.get("MoneyHubAdmin", `/leasing/interest`, {
      queryStringParameters: {
        name: "FEE_TRANSFER",
      },
    });
    const feeInspection = await API.get("MoneyHubAdmin", `/leasing/interest`, {
      queryStringParameters: {
        name: "FEE_INSPECTION",
      },
    });
    const feeService = await API.get("MoneyHubAdmin", `/leasing/interest`, {
      queryStringParameters: {
        name: "FEE_SERVICE",
      },
    });

    let switch_val = {};

    for (const switchItem of switchVal?.interests) {
      switch_val = {
        ...switch_val,
        [switchItem.name]: switchItem.value,
      };
    }

    return {
      switch_val,
      interestCar,
      interestMotobike,
      interestNtfPenaltyCar,
      interestNtfPenaltyMotobike,
      interestPenaltyTF,
      interestTF,
      allTFGroups,
      carGroups,
      motobikeGroups,
      feeTransfer: feeTransfer?.FEE_TRANSFER,
      feeInspection: feeInspection?.FEE_INSPECTION,
      feeService: feeService?.FEE_SERVICE,
    };
  } catch (error) {
    console.log("error", error);
    return {
      switch_val: {},
      interestCar: {},
      interestMotobike: {},
      interestNtfPenaltyCar: {},
      interestNtfPenaltyMotobike: {},
      interestPenaltyTF: {},
      interestTF: {},
      allTFGroups: {},
      carGroups: {},
      motobikeGroups: {},
      feeTransfer: {},
      feeInspection: {},
      feeService: {},
    };
  }
};

export const initializeApp = createAsyncThunk(
  "initializeApp/initializeStore",
  async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();

      const {
        switch_val,
        interestCar,
        interestMotobike,
        interestNtfPenaltyCar,
        interestNtfPenaltyMotobike,
        interestPenaltyTF,
        interestTF,
        allTFGroups,
        carGroups,
        motobikeGroups,
        feeInspection,
        feeService,
        feeTransfer,
      } = await initialOther();

      const { email } = user.attributes;
      return {
        switch_val,
        feeInspection,
        feeService,
        feeTransfer,
        interest: {
          ntf: {
            INTEREST_CAR: interestCar?.INTEREST_CAR,
            INTEREST_MOTORBIKE: interestMotobike?.INTEREST_MOTORBIKE,
            INTEREST_NTF_PENALTY_CAR:
              interestNtfPenaltyCar?.INTEREST_NTF_PENALTY_CAR,
            INTEREST_NTF_PENALTY_MOTORBIKE:
              interestNtfPenaltyMotobike?.INTEREST_NTF_PENALTY_MOTORBIKE,
          },
          tf: {
            INTEREST_PENALTY_TF: interestPenaltyTF?.INTEREST_PENALTY_TF,
            INTEREST_TF: interestTF?.interests,
          },
        },
        group: {
          tf: [...allTFGroups?.groups],
          ntf: [...carGroups?.groups, ...motobikeGroups?.groups],
        },
        user: {
          username: user.username,
          email,
          groups: user.signInUserSession.accessToken.payload["cognito:groups"],
        },
      };
    } catch (error) {
      return {
        group: {},
        user: null,
      };
    }
  }
);

const initializeAppStore = createSlice({
  name: "user",
  initialState: {
    user: null,
  },
  reducers: {},
  extraReducers: {
    [initializeApp.pending]: (state, action) => {
      state.status = "loading";
    },
    [initializeApp.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.feeInspection = action.payload.feeInspection;
      state.feeService = action.payload.feeService;
      state.feeTransfer = action.payload.feeTransfer;
      state.switch_val = action.payload.switch_val;
      state.user = action.payload.user;
      state.group = action.payload.group;
      state.interest = action.payload.interest;
    },
  },
});

export default initializeAppStore.reducer;
